export default __webpack_public_path__ + "static/media/moto.0dee34fd.png";